import React, { useRef } from "react";
import Header from "../Components/Header";
import HeroSection from "./Hero";
 import Solutions from "./Redefining";
import Team from "./Team";
 import Commitment from "./threeSection";
import Footer from "../Components/Footer";
import DeploymentSection from "./PartnersTennet";
import CTASection from "./CtaSection";

function TennetHome() {
  const heroRef = useRef(null); // Ref untuk HeroSection

  return (
    <div>
      <Header heroRef={heroRef} />
      <main>
        <HeroSection ref={heroRef} /> {/* Terima prop ref */}
        <Solutions />
        <Commitment />
        <Team />
        <DeploymentSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}

export default TennetHome;
